import { render, staticRenderFns } from "./SliderSecond.vue?vue&type=template&id=553ab422&scoped=true&"
import script from "./SliderSecond.vue?vue&type=script&lang=js&"
export * from "./SliderSecond.vue?vue&type=script&lang=js&"
import style0 from "./SliderSecond.vue?vue&type=style&index=0&id=553ab422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553ab422",
  null
  
)

export default component.exports